import { HttpClient } from '../httpClient';
import CalendarItemResponse from '../responses/calendarItemResponse';
import CalendarItemsResponse from '../responses/calendarItemsResponse';
import { BaseResponse } from '../responses/baseResponse';
import CalendarItemRequest from '../requests/calendarItemRequest';

const httpClient = new HttpClient();

export const getCalendarItem = async (CalendarItemId: number) => {
  return httpClient.get<CalendarItemResponse>({
    url: `/v1/CalendarItems/${CalendarItemId}`,
    requiresToken: true,
  });
};

export const getCalendarItemsByDistrictId = async (DistrictId: number) => {
  return httpClient.get<CalendarItemsResponse>({
    url: `/v1/CalendarItems/ByDistrict/${DistrictId}`,
    requiresToken: true,
  });
};

export const createCalendarItem = async (CalendarItemrequest: CalendarItemRequest) => {
  return httpClient.post<CalendarItemResponse>({
    url: '/v1/admin/CalendarItems',
    payload: CalendarItemrequest,
    requiresToken: true,
  });
};

export const updateCalendarItem = async (
  CalendarItemId: number,
  CalendarItemrequest: CalendarItemRequest
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/CalendarItems/${CalendarItemId}`,
    payload: CalendarItemrequest,
    requiresToken: true,
  });
};

export const deleteCalendarItem = async (CalendarItemId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/CalendarItems/${CalendarItemId}`,
    requiresToken: true,
  });
};
